module.exports = __webpack_public_path__ + "static/img/banner.6a448bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/banner.png
// module id = 08hF
// module chunks = 1